
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.622 3.274h0a.762.762 0 01-.547.391h0l-2.796.464 1.977 1.977h0a.753.753 0 01.212.645s0 0 0 0l-.414 2.75L5.61 8.259h0a.766.766 0 01.67 0s0 0 0 0l2.557 1.244-.415-2.751h0a.753.753 0 01.213-.645l1.977-1.977-2.796-.464h0a.762.762 0 01-.548-.39v-.001L5.946.794l-1.324 2.48zm-3.81.932s0 0 0 0h0zm10.267 0h0z","stroke":"#98C1DD"}})])
          )
        }
      }
    